export default __webpack_public_path__ + "static/media/eighteen.58882665.png";